import React from "react";
import { StyleSheet, Text } from "react-native";
import Icons from "@expo/vector-icons/MaterialCommunityIcons";
import { View } from "../shared/Themed";
import { DatePickerInput } from "react-native-paper-dates";
import { ReadOnlyProps } from "../../utils/templates";
import { ValidRangeType } from "react-native-paper-dates/lib/typescript/Date/Calendar";

interface Props {
  required?: boolean;
  disabled?: boolean;
  title: string;
  value: Date;
  width: string | number;
  defaultText: string;
  validRange?: ValidRangeType;
  setDate: (event: any) => void;
}

export const DateInputControl: React.FC<ReadOnlyProps<Props>> = ({
  required = false,
  title,
  disabled = false,
  value,
  width,
  defaultText,
  validRange,
  setDate,
}: ReadOnlyProps<Props>) => {
  const DatePickerInputAny = DatePickerInput as any;

  return (
    <View style={{ flexDirection: "column", width: width as any, marginTop: 14 }}>
      <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 6 }}>
        <Text style={styles.label}>
          {title}
        </Text>
        {required && <Icons name="star" size={8} color="#EF4444" style={{ marginLeft: 4 }} />}
      </View>
      <View>
        <DatePickerInputAny
          style={styles.dateInput as any}
          disabled={disabled}
          mode="single"
          label=""
          locale="en-AU"
          validRange={validRange}
          value={value}
          onChange={(val: any) => setDate(val)}
          inputMode="start"
          key="datePickerInput"
          withDateFormatInLabel={false}
          activeUnderlineColor="transparent"
          underlineColor="transparent"
          placeholder={defaultText}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  label: {
    fontSize: 13,
    fontWeight: "600",
    color: "#374151",
    textAlign: "left",
  },
  dateInput: {
    height: 44,
    width: "100%",
    backgroundColor: "#F9FAFB",
    borderRadius: 8,
    borderColor: "#D1D5DB",
    borderWidth: 1,
  },
});
